module.exports = __webpack_public_path__ + "static/media/chat-grey-icon.f25d1076.svg";